import { StorageAdapter } from './stores/adapters/storage-adapter';
import { RelationInterface, SessionInterface } from '../interfaces';

export const getRelation = (): RelationInterface => {
    const storage = new StorageAdapter();
    return storage.get('relation') as RelationInterface;
};

export const getSession = (): SessionInterface => {
    const storage = new StorageAdapter();
    return storage.get('session') as SessionInterface;
};

export const isLoggedIn = (): boolean => !!getSession() || false;

export const getLastName = (): string => getRelation()?.surname;

export const getFullWrittenName = (): string => getRelation()?.name;

export const isMale = (): boolean => getRelation()?.gender_code === 'M';

export const getUserId = (): string => getRelation()?.relation_id.toString();

export const getPrimaryEmail = (): string => getRelation()?.primary_email_address.email_address;

export const updateUserState = (): void => {
    const event = new CustomEvent('userStateChange', {
        detail: {
            isLoggedIn: isLoggedIn(),
            userName: getFullWrittenName()
        }
    });
    window.dispatchEvent(event);
};

// Make globaly accessable so Angular app's can invoke a menu update
window['updateUserState'] = updateUserState;
